import React from 'react';
import { injectIntl } from 'react-intl';
import {
    MaintenanceRoot,
    IllustrationWrapper,
    MainTitle,
    SecondaryTitle,
    DescriptionText,
    ScheduleBox,
    ScheduleBadge,
    ScheduleTimeText,
    ScheduleNotice,
    InfoSection,
    InfoHighlight,
    InfoFooter,
} from './Styled/MaintenanceStyled';
import MaintenanceCryingEgg from '@/common/Images/MaintenanceCryingEgg.svg';

const Maintenance = ({ intl }) => {
    return (
        <MaintenanceRoot>
            <IllustrationWrapper>
                <img src={MaintenanceCryingEgg} alt="Maintenance" />
            </IllustrationWrapper>

            <MainTitle>
                DB 버전 업그레이드 작업에 따른
            </MainTitle>
            <SecondaryTitle>
                서비스 일시 중지 안내
            </SecondaryTitle>

            <DescriptionText>
                {`포코로 서비스를 이용해 주시는 고객 여러분께 안내드립니다.\n보다 안전하고 안정적인 서비스 제공을 위해\n현재 DB 버전 업그레이드 작업이 진행 중입니다.`}
            </DescriptionText>

            <ScheduleBox>
                <ScheduleBadge>작업 일정</ScheduleBadge>
                <ScheduleTimeText>
                    2026년 3월 23일 (월) 00:00 ~ 01:00 (1시간)
                </ScheduleTimeText>
                <ScheduleNotice>
                    * 작업 일정은 시스템 사정에 따라 다소 변동될 수 있습니다.
                </ScheduleNotice>
            </ScheduleBox>

            <InfoSection>
                <InfoHighlight>
                    작업 시간 동안 POKORO 디바이스 및
                    <br />
                    앱 이용이 일시 중지됩니다.
                </InfoHighlight>
                <InfoFooter>
                    {`작업 완료 후 정상적으로 서비스를 이용하실 수 있습니다.\n이용에 불편을 드려 죄송합니다.\n보다 안정적인 서비스 제공을 위해 최선을 다하겠습니다.`}
                </InfoFooter>
            </InfoSection>
        </MaintenanceRoot>
    );
};

export default injectIntl(Maintenance);
